import { format, parseISO } from "date-fns";
import { sv } from "date-fns/locale";

export const classNames = (...args) => {
    const classes = [];

    for (const arg of args) {
        if (!arg) continue;

        if (typeof arg === "string") {
            classes.push(arg);
            continue;
        }

        if (Array.isArray(arg)) {
            classes.push(...arg.filter(Boolean));
            continue;
        }

        if (typeof arg === "object") {
            for (const [key, value] of Object.entries(arg)) if (value) classes.push(key);
        }
    }

    return classes.join(" ");
};

export const darkenHex = (hex, amount = 0.15) => {
    if (!hex?.startsWith("#")) return hex;

    const num = parseInt(hex.slice(1), 16);
    let r = (num >> 16) & 0xff;
    let g = (num >> 8) & 0xff;
    let b = num & 0xff;

    r = Math.round(r * (1 - amount));
    g = Math.round(g * (1 - amount));
    b = Math.round(b * (1 - amount));

    return "#" + [r, g, b].map((v) => v.toString(16).padStart(2, "0")).join("");
};

export const getNowHHmm = () => {
    return new Date().toLocaleTimeString("sv-SE", {
        hour: "2-digit",
        minute: "2-digit",
    });
};

export const normalizeTime = (time) => {
    if (!time) return null;

    return time.length === 5 ? time : time.slice(0, 5);
};

export const getSelectedDate = () => {
    const params = new URLSearchParams(window.location.search);

    return params.get("date");
};

export const formatDateDisplay = (dateStr) => {
    const date = parseISO(dateStr);

    const day = format(date, "d");
    const month = format(date, "MMM", { locale: sv }).replace(".", "");
    const year = format(date, "yyyy");

    return `${day} ${month} ${year}`;
};

export const isValidEAN13 = (ean) => {
    if (!/^\d{13}$/.test(ean)) return false;

    const digits = ean.split("").map(Number);
    const checksum = digits.pop();

    const sum = digits.reduce((acc, num, i) => acc + num * (i % 2 === 0 ? 1 : 3), 0);
    const calc = (10 - (sum % 10)) % 10;

    return calc === checksum;
};


export const toSetter = (name) => {
    return 'set' + name
        .split('_')
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join('');
};
